export type FooterData = {
  appLinks: AppLink;
  infoLinks: InfoLink[];
  privacyLinks: Link[];
  socialLinks: SocialLink[];
  configFooter: {
    visible: boolean;
    socialLinks?: boolean;
    appLinks?: boolean;
    privacyLinks?: boolean;
    infoLinks?: boolean;
  };
  profile: string;
};

type Link = {
  id: string;
  name: string;
  target: string;
  url: string;
  icon?: string;
  properties?: {
    [key: string]: any;
  };
};

interface SocialLink extends Link {
  className?: string;
}
export interface InfoLink extends Link {
  index?: string;
  expanded?: boolean;
  collapsible?: InfoLink[];
}
interface AppLink {
  links: Link[];
  appImage: string;
  qrCodeImage: string;
}

export enum LinkType {
  INTERNAL = "INTERNALURL",
  EXTERNAL = "EXTERNALURL",
}

export const ICON_LIST = [
  {
    name: "Facebook",
    className: "tpd-icon icon-Square_Fbook iconfont",
  },
  {
    name: "Instagram",
    className: "tpd-icon icon-Square_Inst iconfont",
  },
  {
    name: "X",
    className: "tpd-icon icon-Square_X iconfont",
  },
  {
    name: "LinkedIn",
    className: "tpd-icon icon-Linkedin1 iconfont",
  },
  {
    name: "Youtube",
    className: "tpd-icon icon-Square_Ytube iconfont",
  },
  {
    name: "Plus",
    className: "tpd-icon icon-Square_Plus iconfont",
  },
];
